import script from "./GestorPagos.vue?vue&type=script&setup=true&lang=js"
export * from "./GestorPagos.vue?vue&type=script&setup=true&lang=js"

import "./GestorPagos.vue?vue&type=style&index=0&id=80514742&scoped=true&lang=css"

import exportComponent from "/var/www/html/manual/expositores/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80514742"]])

export default __exports__